var init$1 = function () {
    var style = document.createElement('style');
    style.innerHTML = "\n    .sy-loader {\n      height: 100%;\n      width: 100%;\n      background: rgba(0, 0, 0, 0.52);\n      background-color: rgba(0, 0, 0, 0.52);\n      background-position-x: 0%;\n      background-position-y: 0%;\n      background-repeat: repeat;\n      background-image: none;\n      background-size: auto;\n      background-image: url(\"data:image/svg+xml,%3Csvg width='38' height='38' viewBox='0 0 38 38' xmlns='http://www.w3.org/2000/svg' stroke='%23fff'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(1 1)' stroke-width='2'%3E%3Ccircle stroke-opacity='.5' cx='18' cy='18' r='18'/%3E%3Cpath d='M36 18c0-9.94-8.06-18-18-18'%3E%3CanimateTransform attributeName='transform' type='rotate' from='0 18 18' to='360 18 18' dur='1s' repeatCount='indefinite'/%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E\"),url(\"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='57px' height='57px' viewBox='0 0 57 57' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-347.000000, -142.000000)' fill='%23FFFFFF' fill-rule='nonzero'%3E%3Cg transform='translate(347.000000, 142.000000)'%3E%3Cpath d='M14.0608761,17.653767 C14.0608761,15.6717143 15.6697613,14.0626285 17.651567,14.0626285 L39.3484328,14.0626285 C41.3302386,14.0626285 42.9391239,15.6717143 42.9391239,17.653767 L42.9391239,22.2430361 L39.6893887,22.2430361 L39.6893887,17.653767 C39.6893887,17.4655075 39.536669,17.3127687 39.3484328,17.3127687 L17.651567,17.3127687 C17.463331,17.3127687 17.3106112,17.4655075 17.3106112,17.653767 L17.3106112,26.5374837 C17.3106112,26.725743 17.463331,26.878482 17.651567,26.878482 L39.3484328,26.878482 C41.3302386,26.878482 42.9391239,28.4875677 42.9391239,30.4696205 L42.9391239,39.3533371 C42.9391239,41.3353899 41.3302386,42.9444756 39.3484328,42.9444756 L17.651567,42.9444756 C15.6697613,42.9444756 14.0608761,41.3353899 14.0608761,39.3533371 L14.0608761,34.764068 L17.3106112,34.764068 L17.3106112,39.3533371 C17.3106112,39.5415966 17.463331,39.6943355 17.651567,39.6943355 L39.3484328,39.6943355 C39.536669,39.6943355 39.6893887,39.5415966 39.6893887,39.3533371 L39.6893887,30.4696205 C39.6893887,30.281361 39.536669,30.1286221 39.3484328,30.1286221 L17.651567,30.1286221 C15.6697613,30.1286221 14.0608761,28.5195364 14.0608761,26.5374837 L14.0608761,17.653767 L14.0608761,17.653767 Z' id='Path'%3E%3C/path%3E%3Cpath d='M7.03221384,10.6206768 C7.03221384,8.63862404 8.64109913,7.02953823 10.6229048,7.02953823 L46.3770952,7.02953823 C48.3589008,7.02953823 49.9677861,8.63862404 49.9677861,10.6206768 L49.9677861,18.4387736 L46.7180509,18.4387736 L46.7180509,10.6206768 C46.7180509,10.4324173 46.5653312,10.2796784 46.3770952,10.2796784 L10.6229048,10.2796784 C10.4346688,10.2796784 10.281949,10.4324173 10.281949,10.6206768 L10.281949,26.5339316 C10.281949,26.7221911 10.4346688,26.8749298 10.6229048,26.8749298 L46.3770952,26.8749298 C48.3589008,26.8749298 49.9677861,28.4840158 49.9677861,30.4660684 L49.9677861,46.3793232 C49.9677861,48.361376 48.3589008,49.9704618 46.3770952,49.9704618 L10.6229048,49.9704618 C8.64109913,49.9704618 7.03221384,48.361376 7.03221384,46.3793232 L7.03221384,38.5718826 L10.281949,38.5718826 L10.281949,46.3828753 C10.281949,46.5711348 10.4346688,46.7238737 10.6229048,46.7238737 L46.3770952,46.7238737 C46.5653312,46.7238737 46.7180509,46.5711348 46.7180509,46.3828753 L46.7180509,30.4696205 C46.7180509,30.281361 46.5653312,30.1286221 46.3770952,30.1286221 L10.6229048,30.1286221 C8.64109913,30.1286221 7.03221384,28.5195364 7.03221384,26.5374837 L7.03221384,10.6206768 Z' id='Path'%3E%3C/path%3E%3Cpath d='M0.00355162315,3.59113853 C0.00355162315,1.60908581 1.61243691,0 3.59424263,0 L53.409309,0 C55.3911147,0 57,1.60908581 57,3.59113853 L57,14.6309591 L53.7502648,14.6309591 L53.7502648,3.59113853 C53.7502648,3.40287905 53.5975449,3.25014021 53.409309,3.25014021 L3.59069101,3.25014021 C3.40245497,3.25014021 3.24973519,3.40287905 3.24973519,3.59113853 L3.24973519,26.5339316 C3.24973519,26.7221911 3.40245497,26.8749298 3.59069101,26.8749298 L53.4057574,26.8749298 C55.387563,26.8749298 56.9964483,28.4840158 56.9964483,30.4660684 L56.9964483,53.4088614 C56.9964483,55.3909142 55.387563,57 53.4057574,57 L3.59069101,57 C1.60888529,57 0,55.3909142 0,53.4088614 L0,42.3725931 L3.24973519,42.3725931 L3.24973519,53.4124136 C3.24973519,53.600673 3.40245497,53.7534118 3.59069101,53.7534118 L53.4057574,53.7534118 C53.5939933,53.7534118 53.7467132,53.600673 53.7467132,53.4124136 L53.7467132,30.4696205 C53.7467132,30.281361 53.5939933,30.1286221 53.4057574,30.1286221 L3.59069101,30.1286221 C1.60888529,30.1286221 0,28.5195364 0,26.5374837 L0,3.59113853 L0.00355162315,3.59113853 Z' id='Path'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n      background-size: 75px,25px;\n      background-repeat: no-repeat,no-repeat;\n      background-position: center center,center center;\n      background-color: rgb(0 0 0 / 50%);\n    }\n  ";
    document.head.appendChild(style);
};
var show$1 = function (container, mode) {
    hide$1();
    var loader = document.createElement("div");
    loader.classList.add("sy-loader");
    var wrapper = document.createElement("div");
    wrapper.id = "synaps-loader";
    if (mode === "embed") {
        container.style.position = "relative";
    }
    wrapper.style.position = "absolute";
    wrapper.style.left = "0";
    wrapper.style.top = "0";
    wrapper.style.width = "100%";
    wrapper.style.height = "100%";
    wrapper.style.zIndex = "999";
    wrapper.appendChild(loader);
    container.appendChild(wrapper);
};
var hide$1 = function () {
    var loader = document.querySelectorAll('#synaps-loader');
    if (!loader) {
        return;
    }
    loader.forEach(function (el) {
        el.remove();
    });
};
var Loader = {
    init: init$1,
    show: show$1,
    hide: hide$1,
};

var DEFAULT_CONTAINER_ID = "synaps-wrapper";
var DEFAULT_CORPORATE_URL = "https://verify-corporate.synaps.io";
var DEFAULT_INDIVIDUAL_URL = "https://verify.synaps.io";
var verifyIframe = null;
var synapsInitConfig = null;
var SynapsVerifyConfig = {
    verifyUrl: DEFAULT_INDIVIDUAL_URL,
};
var getContainer = function (mode, containerId) {
    if (mode === "modal") {
        var container = document.getElementById(containerId);
        if (!container) {
            container = document.createElement("div");
            container.id = containerId || DEFAULT_CONTAINER_ID;
            document.body.appendChild(container);
        }
        return container;
    }
    return document.getElementById(containerId || DEFAULT_CONTAINER_ID) || null;
};
var onFinishRef = null;
var onCloseRef = null;
var handleSignRef = null;
var init = function (initConfig) {
    // Destructure initConfig with default values
    var _a = initConfig.containerId, containerId = _a === void 0 ? DEFAULT_CONTAINER_ID : _a, onFinish = initConfig.onFinish, onClose = initConfig.onClose, handleSign = initConfig.handleSign, _b = initConfig.mode, mode = _b === void 0 ? "modal" : _b, _c = initConfig.service, service = _c === void 0 ? "individual" : _c;
    onFinishRef = onFinish || null;
    onCloseRef = onClose || null;
    handleSignRef = handleSign || null;
    // Set the verify URL based on the service
    if (service === "corporate") {
        SynapsVerifyConfig.verifyUrl = DEFAULT_CORPORATE_URL;
    }
    else if (SynapsVerifyConfig.verifyUrl === DEFAULT_CORPORATE_URL) {
        SynapsVerifyConfig.verifyUrl = DEFAULT_INDIVIDUAL_URL;
    }
    // Get or create the container
    var container = getContainer(mode, containerId);
    if (!container) {
        console.error("No element found with id ".concat(containerId));
        return;
    }
    // Remove an existing verifyIframe if it exists
    var iframeContainer = container.querySelector("iframe");
    if (iframeContainer) {
        container.removeChild(iframeContainer);
        iframeContainer.remove();
    }
    // Initialize the loader's CSS
    Loader.init();
    // Initialize event listeners
    initEventListeners();
    // Create an iframe if the mode is "embed"
    if (mode === "embed")
        createIframe(initConfig);
    // Save the config in a variable for reference
    synapsInitConfig = initConfig;
};
var createIframe = function (initConfig) {
    var containerId = initConfig.containerId, sessionId = initConfig.sessionId, lang = initConfig.lang, _a = initConfig.mode, mode = _a === void 0 ? "modal" : _a, walletAddress = initConfig.walletAddress, withFinishButton = initConfig.withFinishButton, tier = initConfig.tier, service = initConfig.service;
    var container = getContainer(mode, containerId || DEFAULT_CONTAINER_ID);
    if (!container) {
        console.error("No element found with id ".concat(containerId));
        return;
    }
    var iframeContainer = container.querySelector("iframe");
    if (iframeContainer)
        return;
    Loader.show(mode === "modal" ? document.body : container, mode);
    var iframeUrl = new URL(SynapsVerifyConfig.verifyUrl);
    if (service === "corporate") {
        iframeUrl.searchParams.append("service", service);
    }
    iframeUrl.searchParams.append("session_id", sessionId);
    iframeUrl.searchParams.append("type", mode);
    iframeUrl.searchParams.append("sem_ver", "4.0.45");
    if (lang)
        iframeUrl.searchParams.append("lang", lang);
    if (walletAddress)
        iframeUrl.searchParams.append("wallet_address", walletAddress);
    if (withFinishButton)
        iframeUrl.searchParams.append("with_finish_button", "true");
    if (tier)
        iframeUrl.searchParams.append("tier", tier);
    var iframe = document.createElement("iframe");
    iframe.src = iframeUrl.href;
    // @ts-ignore
    iframe.allowtransparency = true;
    iframe.allowFullscreen = true;
    iframe.allow = "camera; microphone; midi; encrypted-media; clipboard-write;";
    if (mode === "modal") {
        iframe.style.position = "absolute";
        iframe.style.left = "0";
        iframe.style.top = "0";
    }
    iframe.style.width = "100%";
    iframe.style.height = "100%";
    iframe.style.opacity = "0";
    iframe.style.zIndex = "-1";
    iframe.style.border = "none";
    iframe.style.overflow = "hidden";
    iframe.style.backgroundColor = "transparent";
    iframe.style.background = "transparent";
    iframe.style.transition = "opacity 0.15s ease-in-out";
    verifyIframe = iframe;
    container.appendChild(iframe);
};
var config = function (_a) {
    var verifyUrl = _a.verifyUrl;
    if (verifyUrl)
        SynapsVerifyConfig.verifyUrl = verifyUrl;
};
var hide = function () {
    if (!verifyIframe) {
        console.error("No iframe found");
        return;
    }
    // Hide loader
    Loader.hide();
    verifyIframe.style.zIndex = "-1";
    verifyIframe.style.opacity = "0";
};
var show = function () {
    var _a = (synapsInitConfig || {}).mode, mode = _a === void 0 ? "modal" : _a;
    if (mode === "modal" && synapsInitConfig) {
        createIframe(synapsInitConfig);
    }
    if (!verifyIframe) {
        console.error("No iframe found");
        return;
    }
    verifyIframe.style.opacity = "1";
    verifyIframe.style.zIndex = "999";
};
var eventListenerInit = false;
var initEventListeners = function () {
    if (eventListenerInit)
        return;
    eventListenerInit = true;
    var messageListener = function (event) {
        var _a;
        var originWithoutTrailingSlash = event.origin.replace(/\/$/, "");
        var verifyUrlWithoutTrailingSlash = SynapsVerifyConfig.verifyUrl.replace(/\/$/, "");
        // Check if the event's origin matches the expected verify URL
        if (originWithoutTrailingSlash !== verifyUrlWithoutTrailingSlash) {
            return;
        }
        event.stopPropagation();
        var _b = event.data, type = _b.type, data = _b.data;
        var _c = (synapsInitConfig || {}).mode, mode = _c === void 0 ? "modal" : _c;
        switch (type) {
            case "ready":
                // Hide the loader when the iframe is ready
                Loader.hide();
                if ((synapsInitConfig === null || synapsInitConfig === void 0 ? void 0 : synapsInitConfig.mode) === "embed" && verifyIframe) {
                    verifyIframe.style.opacity = "1";
                    verifyIframe.style.zIndex = "999";
                }
                break;
            case "request_sign":
                // Handle signing requests
                if (handleSignRef) {
                    handleSignRef(data.payload).then(function (signature) {
                        var _a;
                        // Send the signature to the iframe
                        (_a = verifyIframe === null || verifyIframe === void 0 ? void 0 : verifyIframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage({ type: "sign", data: { signature: signature } }, verifyUrlWithoutTrailingSlash);
                    });
                }
                break;
            case "update":
                // Send an update message to the iframe
                (_a = verifyIframe === null || verifyIframe === void 0 ? void 0 : verifyIframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage({ type: "update", data: {} }, verifyUrlWithoutTrailingSlash);
                break;
            case "finish":
                // Handle finish events
                if (mode === "modal") {
                    hide();
                }
                if (onFinishRef) {
                    onFinishRef();
                }
                break;
            case "close":
                // Handle close events
                if (mode === "modal") {
                    hide();
                }
                if (onCloseRef) {
                    onCloseRef();
                }
                break;
        }
    };
    // Add the message listener to the window
    window.addEventListener("message", messageListener);
    // Return a cleanup function to remove the event listener
    return function () {
        window.removeEventListener("message", messageListener);
    };
};
var Synaps = {
    init: init,
    config: config,
    show: show,
    hide: hide,
};

export { Synaps };
//# sourceMappingURL=index.modern.js.map
